import { render } from "./BuyChat.vue?vue&type=template&id=49823d08"
import script from "./BuyChat.vue?vue&type=script&lang=js"
export * from "./BuyChat.vue?vue&type=script&lang=js"

import "./BuyChat.vue?vue&type=style&index=0&id=49823d08&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__